
export const ecommerceCategoriesTableOfContents = [
  {
    id: "importancia",
    title: "Importancia de las fichas de producto",
    subItems: [
      { id: "que-es", title: "¿Qué es una ficha de producto?" },
      { id: "impacto", title: "Impacto en la conversión y ventas" }
    ]
  },
  {
    id: "elementos-fundamentales",
    title: "Elementos fundamentales",
    subItems: [
      { id: "elementos-descriptivos", title: "Elementos descriptivos" },
      { id: "elementos-comerciales", title: "Elementos comerciales" },
      { id: "elementos-logisticos", title: "Elementos logísticos" }
    ]
  },
  {
    id: "optimizacion-seo",
    title: "Optimización SEO",
    subItems: [
      { id: "palabras-clave", title: "Uso de palabras clave" },
      { id: "descripciones", title: "Creación de descripciones únicas" },
      { id: "imagenes", title: "Optimización de imágenes" }
    ]
  },
  {
    id: "estrategias-marketing",
    title: "Estrategias de marketing",
    subItems: [
      { id: "redes-sociales", title: "Integración con redes sociales" },
      { id: "email-marketing", title: "Email marketing y contenidos" }
    ]
  },
  {
    id: "casos-exito",
    title: "Casos de éxito"
  },
  {
    id: "experiencia-usuario",
    title: "Experiencia de usuario",
    subItems: [
      { id: "diseno-web", title: "Diseño web y navegabilidad" },
      { id: "online-vs-fisica", title: "Tienda online vs física" }
    ]
  },
  {
    id: "tendencias-futuras",
    title: "Tendencias futuras",
    subItems: [
      { id: "pim", title: "Product information management" },
      { id: "innovaciones", title: "Innovaciones tecnológicas" }
    ]
  }
];
